// NEW ENTRY (UI rebuild batch 1): every door that records something, in three groups by what it IS — Trades (Book trade,
// Convert, Manager's cheque), Party money (Record money and its weekly modes) and Desk and owner (Move money, expense,
// drawing, capital) — each in order of use (lib/routes.ts ENTRY_SECTIONS; his words, 1 Nov 2026). The phone's New tab and
// the laptop's New entry button open it. Adjust balance is not a tile (operator ruling C1, 26 Oct 2026).
//
// EACH GROUP'S GRID FITS ITS TILES (1 Nov 2026 audit, P7: a fourth tile sat alone on a second row beside two empty cells):
// three tiles in three columns, four in two-by-two on a narrower laptop and four across from xl — never one tile alone.
import { PageHead, Tile } from '../../components/v2/kit';
import { ENTRY_SECTIONS, entryRoutes } from '../../lib/routes';

const COLS: Record<number, string> = {
  1: '',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-2 xl:grid-cols-4',
};

export function NewEntry() {
  return (
    <>
      <PageHead title="New entry" />
      {ENTRY_SECTIONS.map((section) => {
        const tiles = entryRoutes(section);
        return (
          <section key={section} className="mb-6">
            <h2 className="mb-3 text-label font-medium uppercase tracking-wider text-tg-hint">{section}</h2>
            <div className={`grid grid-cols-1 gap-3 lg:gap-4 ${COLS[Math.min(tiles.length, 4)] ?? ''}`}>
              {tiles.map((r) => <Tile key={r.path} to={r.path} icon={r.icon} title={r.title} sub={r.v2?.sub} />)}
            </div>
          </section>
        );
      })}
    </>
  );
}
